import React, { useState } from 'react'
import { TabbedPage, Tab } from 'components/Shared/TabbedPage'
import ReportSettings from 'components/ProjectConfiguration/ReportSettings'
import SectionSettings from 'components/ProjectConfiguration/SectionSettings'
import AdditionalFields from 'components/ProjectConfiguration/AdditionalFields'
import FieldFormsSettingsTabs from 'components/ProjectConfiguration/FieldFormSettingsTabs'
import ChecklistTabs from 'components/ProjectConfiguration/ChecklistSettingsTabs'
import { FormProvider } from 'context/FormContext';
import DomainSettingsTab from 'components/AdminConfig/Domains';
import { projectConfigDomains } from 'utils/DomainUtils';

const tabs = [
    new Tab({ label: "Report Settings", value: "ReportSettings", scope: "ProjectConfig", action: "read" }),
    new Tab({ label: "Section Settings", value: "SectionSettings", scope: "ProjectConfig", action: "read" }),
    new Tab({ label: "Additional Fields", value: "AdditionalFields", scope: "ProjectConfig", action: "read" }),
    new Tab({ label: "Checklist", value: "ChecklistTabs", scope: "ProjectConfig", action: "read" }),
    new Tab({ label: "Field Forms", value: "FieldFormSettingsTabs", scope: "ProjectConfig", action: "read" }),
    new Tab({ label: "Domains", value: "DomainSettingsTab", scope: "ProjectConfig", action: "create" }),
    //  new Tab({ label: "Artifacts Sub Types", value: "ArtifactsSubTypes" }),
]

const Projects = () => {
    const [activeTab, setActiveTab] = useState("ReportSettings")
    return (
        <FormProvider>
            <TabbedPage
                tabs={tabs}
                activeTab={activeTab}
                tabSetterFunc={setActiveTab}
            >
                {(() => {
                    switch (activeTab) {
                        case "ReportSettings": return <ReportSettings />
                        case "SectionSettings": return <SectionSettings />
                        case "AdditionalFields": return <AdditionalFields />
                        case "ChecklistTabs": return <ChecklistTabs />
                        case "FieldFormSettingsTabs": return <FieldFormsSettingsTabs />
                        case "DomainSettingsTab": return <DomainSettingsTab domains={projectConfigDomains} />
                        //     case "ArtifactsSubTypes": return <ArtifactsSubTypes />
                        default: return <ReportSettings />
                    }
                })()}
            </TabbedPage>
        </FormProvider>
    )
}

export default Projects